// import { NavbarComponent } from "../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { TableLandingSupportComponent } from "../../components/SupportSystem/TableLandingSupportComponent";
import { Footer } from "../../components/share/Footer";


export function TableLandingSupportContainer() {
    const title = "รายการคำขอรับเงินช่วยเหลือหรืออุดหนุน"
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={title}></HeadTitle>
            <TableLandingSupportComponent />
            <Footer />
        </div>
    );
}
